import { render, staticRenderFns } from "./SecurityKeys.vue?vue&type=template&id=94f7cc4c"
import script from "./SecurityKeys.vue?vue&type=script&lang=ts"
export * from "./SecurityKeys.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports